import { AxiosResponse } from 'axios';
import { api } from './base/api';
import {
  ProcurementHistoricalDetailsRequest,
  ProcurementHistoricalRequest
} from '../models/request';
import {
  ProcurementHistoricalDetailsResponse,
  ProcurementHistoricalResponse
} from '../models/response';
import { Result } from '../models/common/resultResponse';
import { IProcurementHistoricalApi } from './base';
import { PaginationResponse } from '../models/common/paginationResponse';

const baseRoute: string = 'ProcurementHistorical';

export class ProcurementHistoricalApi extends IProcurementHistoricalApi {
  getHeader(
    request: ProcurementHistoricalRequest
  ): Promise<AxiosResponse<PaginationResponse<ProcurementHistoricalResponse>>> {
    return api.get(`${baseRoute}/getheader`, { params: request });
  }

  getDetails(
    request: ProcurementHistoricalDetailsRequest
  ): Promise<
    AxiosResponse<Result<ProcurementHistoricalDetailsResponse[]>, any>
  > {
    return api.get(`${baseRoute}/getdetails`, { params: request });
  }
}

